import helpers from '../helpers';
import { arrayUnion, arrayRemove } from 'vuex-easy-firestore';
import { increment } from 'vuex-easy-firestore';
import fb from '@/firebaseConfig';
import Vue from 'vue';
import noteActions from './noteActions';
import cardActions from './cardActions';

////////////////////// functions ///////////////////////
const isSequetial = function(tempArray) {
  tempArray.sort(function(a, b) {
    return a - b;
  });
  for (let i = 0; i < tempArray.length - 1; i++) {
    if (tempArray[i + 1] - tempArray[i] !== 1) {
      return false;
    }
  }
  return true;
};
const pagesModules = {
  //  Easy VUEX firestore configuration
  firestorePath: 'pages',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'pages',
  statePropName: 'pages',
  namespaced: true, // automatically added
  sync: {
    patchHook: function(updateStore, doc, store) {
      // console.log(store);
      console.log('patch hook', doc);
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'localChange',
      //   collection: 'pages',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      //store.state.pages.pages[pageId].noteCards[cardId].title = title;
      // function dotNotate(obj, target, prefix) {
      //   (target = target || {}), (prefix = prefix || '');
      //   Object.keys(obj).forEach(function(key) {
      //     if (typeof obj[key] === 'object' && !obj[key].seconds) {
      //       dotNotate(obj[key], target, prefix + key + '.');
      //     } else {
      //       return (target[prefix + key] = obj[key]);
      //     }
      //   });
      //   return target;
      // }
      // const updates = dotNotate(doc);
      // console.log(updates);
      // const updateKeys = Object.keys(updates);
      // let docId = updates.id;

      // updateKeys.forEach((k, n) => {
      //   if (n == 0) {
      //     // first key is page id
      //     return;
      //   }
      //   const pathArray = k.split('.');
      //   const key = pathArray.pop();
      //   console.log(pathArray);
      //   const updateObject = pathArray.length
      //     ? get(store.state.pages.pages[docId], pathArray)
      //     : store.state.pages.pages[docId];
      //   console.log(updateObject);
      //   console.log(key);
      //   Vue.set(updateObject, key, updates[k]);
      //   //Vue.set(store.state.pages.pages[docId], k, updates[k]);
      //   // update firestore
      // });
      // const fbUpdate = { ...updates };
      // delete fbUpdate.id;
      // console.log(fbUpdate);
      // fb.pagesCollection
      //   .doc(docId)
      //   .update(fbUpdate)
      //   .then(r => console.log(r))
      //   .catch(e => console.log(e));
      updateStore(doc);
    },
    patchHookBeforeSync: function(updateFirestore, doc) {
      // console.log('patch hook before sync', doc);
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'beforeSync',
      //   collection: 'pages',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      updateFirestore(doc);
    }
  },
  serverChange: {
    modifiedHook: function(updateStore, doc) {
      console.log('server change', doc);
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'serverChange',
      //   collection: 'pages',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      updateStore(doc);
    }
  },
  state: {
    pages: {}
  },
  getters: {
  },
  mutations: {
    mutateCardTitle(state, { pageId, cardId, title }) {
      //state.pages[pageId].noteCards[cardId].title = title;
      Vue.set(state.pages[pageId].noteCards[cardId], 'title', title);
    }
  },
  actions: {
    ...noteActions,
    ...cardActions,
    async subscribeToContextPages({ state, dispatch }, { contextId }) {
      if (!contextId) {
        throw 'no id was provided for the context to which you want to subscribe to its pages';
      }
      await dispatch('openDBChannel', { clauses: { where: [['context', '==', contextId]] } });
    },
    unsubscribeToContextPages({ dispatch }) {
      dispatch('closeDBChannel', { clearModule: true });
    },
    /****** V7 ACTIONS      */
    updatePageTitle({ rootGetters, dispatch }, { pageId, title }) {
      //  check if this is the basepage
      const context = rootGetters['context/context'];
      if (context.basePage == pageId) {
        dispatch(
          'context/updateContextText',
          { text: title, contextId: context.id },
          { root: true }
        );
      }
      dispatch('patch', { id: pageId, title });
    },
    updatePageDescription({ dispatch }, { pageId, description }) {
      dispatch('patch', { id: pageId, description });
    },
    updatePageType({ dispatch }, { pageId, type }) {
      dispatch('patch', { id: pageId, type });
    },
    updatePageImportant({ dispatch }, { pageId, value }) {
      dispatch('patch', { id: pageId, important: value });
    },
    updatePageEvaluation({ dispatch }, { pageId, answer, confidence }) {
      if (answer == undefined && confidence == undefined) {
        throw 'input answer and confidence was either not provided or is undefined';
      }

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', {
        id: pageId,
        authorAnswer: {
          answer,
          confidence
        }
      });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      dispatch('track/trackEvent', { action: 'Add question answer' }, { root: true });
    },
    //  ADD PAGE FOR NEW VERSION
    async addPage(
      { dispatch, rootState, getters, rootGetters },
      { contextId, section, template = false, order, title = '', noWait = false, pageType = 0 }
    ) {
      if (order == undefined) {
        throw new Error('Order is undefined');
      }
      //get the id's that we will need
      let localContextId = contextId;
      const pageId = getters['dbRef'].doc().id;

      if (localContextId == undefined) {
        localContextId = rootState.context.subscribedId;
      }
      const userId = rootGetters['auth/userId'];

      //make a new page dataset
      const newPageData = {
        id: pageId,
        title,
        description: '',
        authorAnswer: { answer: null, confidence: null },
        context: localContextId,
        isNewType: true, // temp for testing new software
        order: order,
        type: pageType,
        createdBy: userId,
        createdOn: new Date(),
        syncIds: [],
        pageNotes: {},
        noteCards: {}
      };

      // if (!template) {
      //   //  no template, make a dummy entry for the first note
      //   const tempId = getters['dbRef'].doc().id;
      //   const firstNote = {
      //     id: tempId,
      //     createdBy: userId,
      //     createdOn: new Date(),
      //     order: 0,
      //     type: 'note',
      //     content: {
      //       html: '',
      //       widgetType: null,
      //       widgetData: {}
      //     }
      //   };

      //   //append the dummy entry to the note
      //   newPageData.noteBlocks[tempId] = firstNote;
      // } else {
      if (template) {
        //  parse the template into a noteBlocks
        template.forEach((t, i) => {
          // const cardId = getters['dbRef'].doc().id;

          // const card = {
          //   id: cardId,
          //   assignedTo: [],
          //   createdBy: userId,
          //   createdOn: fb.util.timestamp.now(),
          //   updatedOn: fb.util.timestamp.now(),
          //   order: i,
          //   state: 0,
          //   summary: t.summary,
          //   title: t.title
          // };

          // newPageData.noteCards[cardId] = card;
          if (t.pageNotes) {
            t.pageNotes.forEach((n, i) => {
              const newId = getters['dbRef'].doc().id;
              const note = {
                id: newId,
                createdBy: userId,
                createdOn: new Date(),
                order: i,
                type: 'note',
                content: {
                  html: n.text,
                  widgetType: null,
                  widgetData: {},
                  noteType: n.noteType || null
                }
              };
              newPageData.pageNotes[newId] = note;
            });
          }
        });
      }
      //  create an empty line
      const newId = getters['dbRef'].doc().id;
      const note = {
        id: newId,
        createdBy: userId,
        createdOn: new Date(),
        order: 0,
        type: 'note',
        content: {
          html: '',
          widgetType: null,
          widgetData: {},
          noteType: null
        }
      };
      newPageData.pageNotes[newId] = note;

      if (noWait) {
        dispatch('insert', newPageData);
        return pageId;
      } else {
        //add the note to vuex and firestore using vuex-easy-firestore
        await dispatch('insert', newPageData);
        //  Also need up update page order if not last page

        return pageId;
      }
    },
    movePage({ state, dispatch }, { pageId, toOrder, toSection }) {
      if (pageId == undefined || toSection == undefined) {
        throw new Error(
          'Undefined Required Argument. pageId: ' + pageId + ', toSection:' + toSection
        );
      }
      const page = state.pages[pageId];
      const pages = Object.values(state.pages);
      const pageUpdates = [{ id: pageId, section: toSection, order: toOrder }];
      const toSectionPages = pages.filter(p => p.section == toSection && !p.toDelete);
      if (!toSection || toSection == page.section) {
        //  moving within section
        if (page.order > toOrder) {
          // moving back
          toSectionPages.forEach(p => {
            if (p.order >= toOrder && p.order < page.order) {
              pageUpdates.push({ id: p.id, order: increment(1) });
            }
          });
        } else {
          // moving forward
          // moving back
          toSectionPages.forEach(p => {
            if (p.order <= toOrder && p.order > page.order) {
              pageUpdates.push({ id: p.id, order: increment(-1) });
            }
          });
        }
      } else {
        // moving to a new section
        // adjust fromSectionPages
        const fromSectionPages = pages.filter(p => p.section == page.section && !p.toDelete);
        fromSectionPages.forEach(p => {
          if (p.order > page.order) {
            pageUpdates.push({ id: p.id, order: increment(-1) });
          }
        });
        // adjust toSectionPages
        toSectionPages.forEach(p => {
          if (p.order > toOrder) {
            pageUpdates.push({ id: p.id, order: p.order + 1 });
          }
        });
      }
      pageUpdates.forEach(u => {
        dispatch('patch', u);
      });
    },
    removePage({ dispatch, getters, state }, { pageId }) {
      //get the id's that we will need
      if (pageId == undefined) {
        throw 'no id was provided for the new page';
      }
      //  fix remaining page order
      // const pageToDelete = state.pages[pageId];

      // const pageUpdates = [];
      // if (pageToDelete.section) {
      //   const coPages = getters.pagesBySection[pageToDelete.section];
      //   coPages.forEach(p => {
      //     if (p.order > pageToDelete.order) {
      //       pageUpdates.push({ id: p.id, order: increment(-1) });
      //     }
      //   });
      // }

      dispatch('patch', { id: pageId, toDelete: true });
      // pageUpdates.forEach(update => {
      //   dispatch('patch', update);
      // });
    },
    //********************* */
    //********************* */
    //********************* */
    createNewPage(
      { dispatch, rootState, getters, rootGetters },
      { pageId, contextId, template = false }
    ) {
      //get the id's that we will need
      let localContextId = contextId;
      if (pageId == undefined) {
        throw 'no id was provided for the new page';
      }
      if (localContextId == undefined) {
        localContextId = rootState.context.subscribedId;
      }
      const userId = rootGetters['auth/userId'];

      //make a new page dataset
      const newPageData = {
        id: pageId,
        title: '',
        context: localContextId,
        createdBy: userId,
        createdOn: new Date(),
        syncIds: [],
        noteBlocks: {}
      };

      // if (!template) {
      //   //  no template, make a dummy entry for the first note
      //   const tempId = getters['dbRef'].doc().id;
      //   const firstNote = {
      //     id: tempId,
      //     createdBy: userId,
      //     createdOn: new Date(),
      //     order: 0,
      //     type: 'note',
      //     content: {
      //       html: '',
      //       widgetType: null,
      //       widgetData: {}
      //     }
      //   };

      //   //append the dummy entry to the note
      //   newPageData.noteBlocks[tempId] = firstNote;
      // } else {
      if (template) {
        //  parse the template into a noteBlocks
        template.forEach((t, i) => {
          const tempId = getters['dbRef'].doc().id;
          const note = {
            id: tempId,
            createdBy: userId,
            createdOn: new Date(),
            order: i,
            type: 'note',
            content: {
              html: t.text,
              widgetType: null,
              widgetData: {},
              noteType: t.noteType || null
            }
          };
          newPageData.noteBlocks[tempId] = note;
        });
      }

      //add the note to vuex and firestore using vuex-easy-firestore
      dispatch('insert', newPageData);
    },
    addNoteBlock(
      { dispatch, getters, rootState },
      { pageId, html = null, widgetInfo = false, order = undefined, noteType = 'support' }
    ) {
      //throw an error if anythin is missing
      if (html == null && !widgetInfo) {
        throw 'no html field was provided for the new note';
      }
      if (order !== undefined && isNaN(order)) {
        throw 'the order provided is not a number';
      }
      if (pageId == undefined) {
        throw 'no pageId was provided for the new note';
      }

      // get the note blocks to determine last item order and to update order later
      const { selectedPageNotes } = getters;

      const newOrder = order !== undefined ? order : selectedPageNotes.length;

      //get necessary Id's (generated for new Id and user ID for created by)
      const id = getters['dbRef'].doc().id;
      const userId = rootState.auth.currentUser.uid;

      //create the update object for the addition of the note
      const noteUpdate = {};
      const { widgetType, widgetData } = widgetInfo;
      noteUpdate[id] = {
        id,
        createdBy: userId,
        createdOn: new Date(),
        updatedOn: fb.util.timestamp.now(),
        order: newOrder,
        type: widgetType ? 'widget' : 'note',
        content: {
          html,
          widgetType: widgetType || null,
          widgetData: widgetData || {},
          noteType
        }
      };

      //update all the other notes that have a greater order than the one being added to be +1
      selectedPageNotes.forEach(noteBlock => {
        if (noteBlock.order >= newOrder) {
          noteUpdate[noteBlock.id] = {
            order: increment(1)
          };
        }
      });

      // if (widgetType === 'resource' && 'resourceId' in widgetData) {
      //   if (!page.syncIds.includes(widgetData.resourceId)) {
      //     console.log(`updating syncIds with resource: ${widgetData.resourceId}`);
      //     dispatch('patch', { id: pageId, syncIds: arrayUnion(widgetData.resourceId) });
      //   }
      // }

      console.log('noteUpdate', noteUpdate);
      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      dispatch('batchSync');
      return id;
    },
    removeNoteBlock({ getters, dispatch }, { noteBlockId, pageId }) {
      console.log('remove note', noteBlockId);
      //get necessary Id's
      if (!noteBlockId) {
        throw 'no NoteBlockId was provided for the note you want to remove';
      }
      if (!pageId) {
        throw 'no pageId was provided for the note you want to remove';
      }

      //find it's order and update all the ones with order greater than it
      const { selectedPageNotes } = getters;
      const currentNoteBlock = selectedPageNotes.find(e => e.id === noteBlockId);
      const { order } = currentNoteBlock;
      const noteBlocksUpdate = {};
      selectedPageNotes.forEach(noteBlock => {
        if (noteBlock.order > order) {
          noteBlocksUpdate[noteBlock.id] = {
            order: increment(-1)
          };
        }
      });

      //delete the field that we no longer need
      noteBlocksUpdate[noteBlockId] = {};
      noteBlocksUpdate[noteBlockId].toDelete = true;

      //update the orders if the object length is not 0
      if (Object.keys(noteBlocksUpdate).length !== 0) {
        dispatch('patch', { id: pageId, notesToDelete: true, noteBlocks: noteBlocksUpdate });
        dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      } else {
        console.log('no order needed updated');
      }
    },
    updateNoteBlockHTML({ dispatch }, { pageId, noteBlockId, html }) {
      //get necessary Id's
      if (!html) {
        throw 'no html field was provided for the updated noteblock html';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = { content: { html }, updatedOn: fb.util.timestamp.now() };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    setNoteType({ dispatch }, { pageId, noteBlockId, noteType }) {
      //get necessary Id's
      if (!noteType) {
        throw 'no type field was provided for the updated noteblock type';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = { content: { noteType }, updatedOn: fb.util.timestamp.now() };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    setNoteStatus({ dispatch }, { pageId, noteBlockId, status }) {
      //get necessary Id's
      if (status == undefined) {
        throw 'no status field was provided for the updated noteblock';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = {
        status,
        updatedOn: fb.util.timestamp.now()
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    setNoteTask({ dispatch }, { pageId, noteBlockId, task, userIds }) {
      //get necessary Id's
      if (task == undefined) {
        throw 'no task field was provided for the updated noteblock';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = {
        content: { task },
        updatedOn: fb.util.timestamp.now()
      };
      if (userIds) {
        noteBlockUpdate[noteBlockId].content.assignedTo = userIds;
      }
      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    clearNoteTask({ dispatch }, { pageId, noteBlockId }) {
      //get necessary Id's
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = {
        content: { task: false, assignedTo: [] },
        updatedOn: fb.util.timestamp.now()
      };
      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    setNoteNeedsAttention({ dispatch }, { pageId, noteBlockId, needsAttention }) {
      //get necessary Id's
      if (needsAttention == undefined) {
        throw 'no needsAttention field was provided for the updated noteblock';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = {
        content: { needsAttention },
        updatedOn: fb.util.timestamp.now()
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    setAssignTo({ dispatch }, { pageId, noteBlockId, userIds }) {
      //get necessary Id's
      if (userIds == undefined) {
        throw 'no userId field was provided for the updated noteblock';
      }
      if (!noteBlockId) {
        throw 'no noteBlockId was provided for the noteblock you want to update';
      }
      if (!pageId) {
        throw 'no pageId was provided for the noteblock you want to update';
      }

      //create the update object
      const noteBlockUpdate = {};
      noteBlockUpdate[noteBlockId] = {
        content: { assignedTo: userIds }
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: pageId, noteBlocks: noteBlockUpdate });
      dispatch('context/addToAuthorIfNecessary', { userIds }, { root: true });
    },
    moveNoteBlocksByOrder({ dispatch, getters }, { ordersToMove, moveLocation, pageId }) {
      if (ordersToMove.constructor !== Array) {
        throw 'input ordersToMove was either not provided or is not an array please check your function inputs and try again';
      }
      if (isNaN(moveLocation)) {
        throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
      }
      if (pageId == undefined) {
        throw 'input pageId was either not provided or undefined please check your function inputs and try again';
      }
      if (!isSequetial(ordersToMove)) {
        throw 'input ordersToMove is not a sequential set of integers please check your function inputs and try again';
      }

      //get the noteBlocks we are intersted in and convert them to an array
      const { selectedPageNotes } = getters;

      //user a helper to update the order on all of the elements
      let noteBlocksUpdate;
      noteBlocksUpdate = helpers.moveHelper(ordersToMove, moveLocation, selectedPageNotes);
      console.log('noteBlocksUpdate', noteBlocksUpdate);

      //send the update to vuex and firestore
      if (Object.keys(noteBlocksUpdate).length !== 0) {
        dispatch('patch', { id: pageId, noteBlocks: noteBlocksUpdate });
        dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      } else {
        throw 'problems generating the update object please check that the moveLocation input value is not included in the ordersToMove Input Array';
      }
    },
    moveNoteBlocksById({ dispatch, getters }, { idsToMove, moveLocation, pageId }) {
      if (idsToMove.constructor !== Array) {
        throw 'input idsToMove was either not provided or is not an array please check your function inputs and try again';
      }
      if (isNaN(moveLocation)) {
        throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
      }
      if (pageId == undefined) {
        throw 'input pageId was either not provided or undefined please check your function inputs and try again';
      }

      //get the noteBlocks we are intersted in and convert them to an array
      const { selectedPageNotes } = getters;

      //get the orders of the provided id's from our helper function
      const ordersToMove = [];
      selectedPageNotes.forEach(noteBlock => {
        if (idsToMove.includes(noteBlock.id)) {
          ordersToMove.push(noteBlock.order);
        }
      });

      //order them using the move by order function
      dispatch('moveNoteBlocksByOrder', { ordersToMove, moveLocation, pageId });
    },
    combineExcerptNoteBlocks({ dispatch, state }, { noteIdToMove, targetId, pageId }) {
      if (noteIdToMove == undefined) {
        throw 'input noteIdToMove was not provided, please check your function inputs and try again';
      }
      if (targetId == undefined) {
        throw 'target was not provided, please check your function inputs and try again';
      }
      if (pageId == undefined) {
        throw 'input pageId was either not provided or undefined please check your function inputs and try again';
      }

      //get the noteBlocks we are intersted in and convert them to an array
      const { pages } = state;
      const page = pages[pageId];
      const { noteBlocks } = page;

      //  Get the excerpt ids to move and combine them with destination
      const excerptIdsToMove = noteBlocks[noteIdToMove].content.widgetData.resourceNoteIds;
      const target = noteBlocks[targetId];

      const resourceNoteIds = target.content.widgetData.resourceNoteIds.concat(excerptIdsToMove);

      //create the update object
      const excerptUpdate = {};
      excerptUpdate[targetId] = { content: { widgetData: { resourceNoteIds } } };
      //  update it
      dispatch('patch', { id: pageId, noteBlocks: excerptUpdate });
      //  delete the old note
      dispatch('removeNoteBlock', { noteBlockId: noteIdToMove, pageId });
    }
  }
};

export default pagesModules;
